/**
 * Created by jv on 30/05/2018.
 */
import CONSTANTS from "Sources/games/chicken-game/config/constants";

export default class Corinne
{
  constructor(scene, x, y)
  {
    this.scene = scene;

    this.sprite = this.scene.add.sprite(x, y, CONSTANTS.ATLAS_KEY, "animations/corinne/0000.png").setOrigin(0.5);

    if(CONSTANTS.DEBUG)
    {
      var graphics = this.scene.add.graphics();
      graphics.lineStyle(1, 0xff0000, 1);

      graphics.strokeRectShape(this.sprite.getBounds());
    }
  }

  destroy()
  {
    this.sprite.destroy();
  }

  startIdleAnimation()
  {
    this.sprite.anims.play("corinne-idle", true);
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/objects/corinne.js